import Vue from "vue";
import {
  Form,
  Field,
  Cell,
  CellGroup,
  Tabbar,
  TabbarItem,
  Tab,
  Tabs,
  Icon,
  Popup,
  Tag,
  Empty,
  Dialog,
  Uploader,
  PullRefresh,
  Popover,
  Swipe,
  SwipeItem,
  Lazyload,
  NoticeBar,
  Rate,
  NavBar,
  Button,
  CountDown,
  Toast,
  DropdownItem,
  DropdownMenu,
  Sticky,
  Radio,
  RadioGroup,
  Badge,
  List,
  Search,
  Overlay,
  Progress,
  Circle,
  ActionSheet,
  ImagePreview,
  CheckboxGroup,
  Checkbox,
  Cascader,
  Loading,
  Collapse,
  CollapseItem,
  Switch,
  Grid,
  GridItem,
  Stepper,
  Area
} from "vant";

Vue.use(Form);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Empty);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Uploader);
Vue.use(Dialog);
Vue.use(PullRefresh);
Vue.use(Popover);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload, {
  loading: require("@/assets/lazy.gif"),

  lazyComponent: true,
});


Vue.use(NoticeBar);
Vue.use(Rate);
Vue.use(NavBar);
Vue.use(Button);
Vue.use(CountDown);
Vue.use(Toast);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Sticky);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Badge);
Vue.use(List);
Vue.use(Search);
Vue.use(Overlay);
Vue.use(Progress);
Vue.use(Circle);
Vue.use(ActionSheet);
Vue.use(ImagePreview);
Vue.use(Checkbox);
Vue.use(Cascader);
Vue.use(CheckboxGroup);
Vue.use(Loading)
Vue.use(Switch)
Vue.use(Grid)
Vue.use(GridItem)


Vue.use(Collapse);
Vue.use(CollapseItem)
Vue.use(Stepper)
Vue.use(Area)
Toast.setDefaultOptions("loading", { forbidClick: true,position: 'middle' ,loadingType: 'spinner' });
Toast.setDefaultOptions({ position: top });
Toast.setDefaultOptions("success",{ position: 'middle'});
Toast.setDefaultOptions("fail",{ position: 'middle'});
Vue.prototype.$toast = Toast;
Vue.prototype.$dailog = Dialog;

Vue.prototype.$preview = ImagePreview;